export const MAPFlowTypes = {
    AUTOPAY_FLOW: 'AUTOPAY_FLOW',
    ONE_TIME_PAYMENT_FLOW: 'ONE_TIME_PAYMENT_FLOW',
    MULTI_PAYMENT_FLOW: 'MULTI_PAYMENT_FLOW'
};
